import React, { Component } from 'react';
import { SubmissionError } from 'redux-form';

import ValidatePortForm from 'components/quick/ValidatePortForm';
import { quickValidatePort } from 'api';
import DisplayPreActivationInfo from 'components/quick/DisplayPreActivationInfo';
import Spinner from 'components/Spinner';

class ValidatePort extends Component {
  state = {
    result: null,
    loading: false,
  };

  handleSubmit = (values) => {
    this.setState({ loading: true });
    return quickValidatePort(values)
      .then((res) => {
        this.setState({ loading: false, result: res.data });
      })
      .catch((err) => {
        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        this.setState({ loading: false, result: null });
        throw new SubmissionError(messages);
      });
  };

  render() {
    const { quickVendors } = this.props;
    const { result, loading } = this.state;

    return (
      <div>
        <h2>Validate Port</h2>
        <div className="relative">
          <ValidatePortForm
            quickVendors={quickVendors}
            onSubmit={this.handleSubmit}
          />
          <Spinner showLoader={loading} />
        </div>
        <DisplayPreActivationInfo data={result} />
      </div>
    );
  }
}

export default ValidatePort;
